export default __webpack_public_path__ + "static/media/fallback_bg.ecfe1a2c.png";